import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';
import Logo from './Logo';
import '../styles/Footer.css';

export default function Footer() {
  const { lang, setLang, t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="vx-footer">
      <div className="vx-footer-inner">

        {/* Brand + copyright */}
        <div className="vx-footer-brand">
          <span className="vx-footer-logo">
            <Logo height={22} />
          </span>
          <span className="vx-footer-sep" aria-hidden="true">·</span>
          <span className="vx-footer-copy">© {year}</span>
        </div>

        {/* Legal links */}
        <nav className="vx-footer-legal" aria-label="Legal">
          <Link to="/kvkk" className="vx-footer-link">KVKK</Link>
          <span className="vx-footer-sep" aria-hidden="true">·</span>
          <Link to="/gizlilik-politikasi" className="vx-footer-link">{t('legal.privacy')}</Link>
          <span className="vx-footer-sep" aria-hidden="true">·</span>
          <Link to="/kullanim-kosullari" className="vx-footer-link">{t('legal.terms')}</Link>
          <span className="vx-footer-sep" aria-hidden="true">·</span>
          <Link to="/cerez-politikasi" className="vx-footer-link">{t('legal.cookies')}</Link>
        </nav>

        {/* Language toggle */}
        <div className="vx-footer-lang" role="group" aria-label="Language">
          <Globe size={12} className="vx-footer-lang-icon" aria-hidden="true" />
          <button
            type="button"
            className={`vx-footer-lang-btn${lang === 'tr' ? ' active' : ''}`}
            onClick={() => setLang('tr')}
            aria-pressed={lang === 'tr'}
          >TR</button>
          <span className="vx-footer-sep" aria-hidden="true">·</span>
          <button
            type="button"
            className={`vx-footer-lang-btn${lang === 'en' ? ' active' : ''}`}
            onClick={() => setLang('en')}
            aria-pressed={lang === 'en'}
          >EN</button>
        </div>

      </div>
    </footer>
  );
}
